import { render, staticRenderFns } from "./map-rectangle.vue?vue&type=template&id=48d0de39&"
import script from "./map-rectangle.vue?vue&type=script&lang=js&"
export * from "./map-rectangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports